import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
    appId: process.env.REACT_APP_FIREBASE_APP_ID as string,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string
};

const app = initializeApp(firebaseConfig);
const messaging: Messaging = getMessaging(app);

export const requestForToken = async (): Promise<string | null> => {
    try {
        let registration;
        if ('serviceWorker' in navigator) {
            const firebaseConfigParams = new URLSearchParams({
                apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
                authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
                projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
                storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
                messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
                appId: process.env.REACT_APP_FIREBASE_APP_ID as string,
                measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string
            }).toString();
            registration = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?${firebaseConfigParams}`);
        }

        const currentToken = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY as string,
            serviceWorkerRegistration: registration
        });

        if (currentToken) {
            console.log('current token for client: ', currentToken);
            localStorage.setItem('fcm_token', currentToken);
            return currentToken;
        } else {
            console.log('No registration token available. Request permission to generate one.');
            return null;
        }
    } catch (err) {
        console.log('An error occurred while retrieving token. ', err);
        return null;
    }
};

export const onMessageListener = (callback: (payload: any) => void) => {
    console.log('onMessageListener');
    return onMessage(messaging, (payload) => {
        console.log('Firebase onMessage triggered with payload:', payload);
        callback(payload);
    });
};

export default app;
